import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getSlideTypesCsat: {
    method: 'GET',
    url: `${configs.baseUrl}/api/slide/slide-types-csat`,
  },
  postSlideTypeFeedback: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide/slide-type-feedback`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

// Per-slide-type CSAT ratings, keyed by slide type (e.g. 'pickAnswer',
// 'marketplace/duck-race'): `{ data: { [type]: { csatPercent, stars, ratingCount } } }`.
const getSlideTypesCsat = async () => {
  const res = await resource.getSlideTypesCsat()
  // vue-resource can resolve network errors as status 0 / ok=false; throw so
  // the caller's catch handles them.
  if (!res.ok) throw Object.assign(new Error(`HTTP ${res.status}`), { response: res })
  return res.body
}

const postSlideTypeFeedback = (payload) => resource.postSlideTypeFeedback(payload)

export default { initResource, getSlideTypesCsat, postSlideTypeFeedback }
